module.exports = __webpack_public_path__ + "img/order_info_tips.b8e09aa7.svg";